import { useState } from "react";
import { Segmented, Spin } from "antd";
import { observer } from "mobx-react-lite";

import { SUBSCRIPTION_PLAN_DESCRIPTIONS } from "../../config";
import { userStore } from "../../stores/userStore";
import { SubscriptionPlan } from "./SubscriptionPlan";
import { TrialBanner } from "./TrialBanner";

import "./SubscriptionPlans.css";

import type { SubscriptionPlan as PlanData } from "../../api/subscription";

interface Props {
  plans: PlanData[];
  isYearly: boolean;
  onSelect: (plan: PlanData, period: string) => void;
}

export const SubscriptionPlans = observer(
  ({ plans, isYearly, onSelect }: Props) => {
    // const { t } = useTranslation();
    const sub = userStore.subscription;
    const [selectedPlanId, setSelectedPlanId] = useState<string>();

    if (!sub) return <Spin />;

    const currentPlanId = sub.plan?.toLowerCase();
    const activePlanId = plans.some((plan) => plan.id === selectedPlanId)
      ? selectedPlanId
      : (plans.find((plan) => plan.id === currentPlanId)?.id ?? plans[0]?.id);

    return (
      <div className="subscription-plans">
        <Segmented
          block
          className="subscription-plans__tabs"
          value={activePlanId}
          onChange={(value) => setSelectedPlanId(String(value))}
          options={plans.map((plan) => ({
            value: plan.id,
            label: plan.name,
          }))}
        />
        <div className="subscription-plans__cards">
          {plans.map((plan) => {
            const isSelected = plan.id === activePlanId;
            return (
              <div
                key={plan.id}
                className={`subscription-plans__card${isSelected ? " subscription-plans__card--active" : ""}`}
              >
                <SubscriptionPlan
                  plan={plan}
                  description={
                    SUBSCRIPTION_PLAN_DESCRIPTIONS[plan.id] ??
                    SUBSCRIPTION_PLAN_DESCRIPTIONS["lemon"]
                  }
                  isYearly={isYearly}
                  isActive={sub.plan?.toLowerCase() === plan.id}
                  isAutopaymentActive={sub.autopayment}
                  currentPeriod={sub.interval}
                  canceledAt={sub.canceled_at}
                  expireAt={sub.expire_at}
                  onSelect={(p) => onSelect(p, isYearly ? "yearly" : "monthly")}
                />
              </div>
            );
          })}
        </div>
        <div className="subscription-plans__trial">
          <TrialBanner goal="trial_plans" />
        </div>
      </div>
    );
  },
);
